import React from "react"
import { Redirect, useHistory } from "react-router-dom"
import { Hidden } from "@material-ui/core"
import useAuth from "../../hooks/modules/account/useAuth"
import useMenuState from "../../hooks/modules/shell/useMenuState"
import Header from "./Header"
import Flyout from "./Flyout"
import Main from "./Main"
import SessionTimeout from "../../components/SessionTimeout"
const AppShell = () => {
    const { isUserAuthenticated } = useAuth()
    const { classes, mobileOpen, handleDrawerToggle, open } = useMenuState()
    const { replace } = useHistory()
    return (
        <>
            <SessionTimeout isAuthenticated={isUserAuthenticated} logOut={() => replace('/login')} />
            {
                !isUserAuthenticated ?
                    <Redirect to="/login" /> :
                    <div className={classes.root}>
                        <Header handleDrawerToggle={handleDrawerToggle} />
                        <Flyout menuObj={{ mobileOpen, handleDrawerToggle, open }} />
                        <div className={classes.mainRoot}>
                            <Hidden mdUp implementation="css">
                                <Main mainClassName={classes.content} />
                            </Hidden>
                            <Hidden smDown implementation="css">
                                <Main mainClassName={open === true ? classes.content : classes.contentShift} />
                            </Hidden>
                        </div>
                    </div>
            }
        </>
    )
}
export default AppShell